import { Log, LogStatus } from '@/types/logs'

export const checkIsLogUnfinished = (log: Log): boolean => {
    return log.status === LogStatus.Incomplete
}
